import { render, staticRenderFns } from "./Fighters.vue?vue&type=template&id=4f810973&lang=pug&"
import script from "./Fighters.vue?vue&type=script&lang=js&"
export * from "./Fighters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports